import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsOfUseComponent } from './terms-of-use.component';
import { PanelModule } from 'primeng/panel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';

@NgModule({
  imports: [
    CommonModule,
    PanelModule,
    ScrollPanelModule,
    CheckboxModule,
    FormsModule,
    ButtonModule,
    SkeletonModule
  ],
  declarations: [TermsOfUseComponent],
  exports: [TermsOfUseComponent]
})
export class TermsOfUseModule { }
